import type { MutableRefObject } from 'react';
import { useState, useRef, useEffect } from 'react';

import LazyloadService from '@services/LazyloadService';

export const useImgVisible = (imgRef: MutableRefObject<HTMLImageElement>) => {
  const [isVisible, setIsVisible] = useState(LazyloadService.nativeLoadingSupport);
  const observer = useRef<IntersectionObserver>(undefined);

  useEffect(() => {
    if (!isVisible) {
      observer.current = new IntersectionObserver((elements) => {
        const intersectedEls = elements.filter((el) => el.isIntersecting);
        setIsVisible(isVisible || !!intersectedEls.length);
        intersectedEls.forEach((el) => observer.current.unobserve(el.target));
      });

      imgRef.current && observer.current.observe(imgRef.current);
    }

    return () => {
      observer.current && observer.current.disconnect();
    };
  }, [imgRef, isVisible]);

  return isVisible;
};
